
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IKTR", function(module, exports) {

$parcel$export(module.exports, "TemplatePreviewWindow", function () { return $d97b2f2c7d425037$export$7dbe3d9b4e16c7ed; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lHjhp = parcelRequire("lHjhp");

var $4VhzM = parcelRequire("4VhzM");

var $5ohHq = parcelRequire("5ohHq");

var $kqt8V = parcelRequire("kqt8V");

var $ik2oV = parcelRequire("ik2oV");
const $d97b2f2c7d425037$var$previewTopBar = null;
const $d97b2f2c7d425037$var$previewBarDot = null;
const $d97b2f2c7d425037$var$previewImage = null; /**
                            * @deprecated These pages are now in Uniform, using the TemplatePreview Uniform component.
                            */ 
const $d97b2f2c7d425037$export$7dbe3d9b4e16c7ed = ({ url: url, alt: alt, templateType: templateType })=>{
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $4VhzM.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _ca0qi2wt _u5f31crf _n3tdi2wt _19bv1crf _4t3i7vkz _vchhusvi _1s1g1y44 _5fbc1y44 _bfhkalr3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhku67f _1yxn1y44 _1ein1y44 _16qsapdr _4mbabn52 _kno315vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $esG4f.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _zulpftgi _kqswstnw _u7co7vkz _rjxp7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                "aria-label": "Zoom In",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kqt8V.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                "aria-label": "Zoom Out",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ik2oV.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _ca0qi2wt _u5f31crf _n3tdi2wt _19bv1crf _4t3i7vkz _vchhusvi _1s1g1y44 _5fbc1y44 _bfhkalr3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhku67f _1yxn1y44 _1ein1y44 _16qsapdr _4mbabn52 _kno315vq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});

parcelRegister("95kuv", function(module, exports) {

$parcel$export(module.exports, "TemplateCtaButtons", function () { return $ce9517abf3e8b64e$export$20303b6b07b1d49e; });
/* template-cta-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $bQawl = parcelRequire("bQawl");
const $ce9517abf3e8b64e$var$ctaContainerStyles = null;
const $ce9517abf3e8b64e$export$20303b6b07b1d49e = ({ name: name, pluginModuleKey: pluginModuleKey })=>{
    const intl = (0, $f6qj2.default)();
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const buttonText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.useTemplate",
        defaultMessage: "Use template"
    });
    const navigateToSignup = (0, $iSvIT.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        openModalForTemplate({
            templateId: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : "",
            templateName: name !== null && name !== void 0 ? name : "",
            productKey: (0, $i8kxh.ProductKeys).CONFLUENCE
        });
    }, [
        openModalForTemplate,
        name,
        pluginModuleKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _zulp14no _1bah1y6m _nssp1h6o _1ogzkb7n _10df1ylp _16vj1ylp _1wm61j6v"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
            className: "cta-button",
            onClick: navigateToSignup,
            size: "small",
            text: buttonText
        })
    });
};

});

parcelRegister("l2OTr", function(module, exports) {

$parcel$export(module.exports, "getIcon", function () { return $d661b68c903e32f4$export$16b26cd5e98d9100; });

var $loA2J = parcelRequire("loA2J");

var $kkNq7 = parcelRequire("kkNq7");

var $2eqAL = parcelRequire("2eqAL");

var $kGv70 = parcelRequire("kGv70");

var $bKqge = parcelRequire("bKqge");

var $judwC = parcelRequire("judwC");

var $iHyWi = parcelRequire("iHyWi");

var $bDTBs = parcelRequire("bDTBs");

var $j6Mjf = parcelRequire("j6Mjf");

var $54Z58 = parcelRequire("54Z58");

var $9TuM8 = parcelRequire("9TuM8");

var $8nSEF = parcelRequire("8nSEF");

var $kPkjS = parcelRequire("kPkjS");

var $dtz0w = parcelRequire("dtz0w");

var $imXhV = parcelRequire("imXhV");

var $bJ0Y9 = parcelRequire("bJ0Y9");

var $1EpFI = parcelRequire("1EpFI");

var $8A4p1 = parcelRequire("8A4p1");

var $d1xAD = parcelRequire("d1xAD");

var $DynGV = parcelRequire("DynGV");

var $cNevM = parcelRequire("cNevM");

var $e9JPb = parcelRequire("e9JPb");

var $lhvME = parcelRequire("lhvME");

var $itghZ = parcelRequire("itghZ");

var $fqjcR = parcelRequire("fqjcR");

var $ixaDK = parcelRequire("ixaDK");

var $aOabo = parcelRequire("aOabo");

var $2YVsr = parcelRequire("2YVsr");

var $cgxwH = parcelRequire("cgxwH");

var $haaTf = parcelRequire("haaTf");

var $egeJ8 = parcelRequire("egeJ8");

var $2HBdl = parcelRequire("2HBdl");

var $iHnIP = parcelRequire("iHnIP");

var $lnsmo = parcelRequire("lnsmo");

var $6akvZ = parcelRequire("6akvZ");
const $d661b68c903e32f4$var$featureIconMap = {
    "analysis": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lnsmo))), {
        label: ""
    }),
    "automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgxwH))), {
        label: ""
    }),
    "business updates": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ixaDK))), {
        label: ""
    }),
    "communication": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j6Mjf))), {
        label: ""
    }),
    "company wiki": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtz0w))), {
        label: ""
    }),
    "content management": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nSEF))), {
        label: ""
    }),
    "decision tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54Z58))), {
        label: ""
    }),
    "deployment strategy": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9JPb))), {
        label: ""
    }),
    "documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPkjS))), {
        label: ""
    }),
    "feedback": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8A4p1))), {
        label: ""
    }),
    "forms": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2eqAL))), {
        label: ""
    }),
    "goal setting": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($judwC))), {
        label: ""
    }),
    "goal tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHyWi))), {
        label: ""
    }),
    "ideation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJ0Y9))), {
        label: ""
    }),
    "intranet": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6akvZ))), {
        label: ""
    }),
    "knowledge base": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bKqge))), {
        label: ""
    }),
    "marketing research": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
        label: ""
    }),
    "note taking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imXhV))), {
        label: ""
    }),
    "onboarding": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($DynGV))), {
        label: ""
    }),
    "operations": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9TuM8))), {
        label: ""
    }),
    "prioritization": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkNq7))), {
        label: ""
    }),
    "problem solving": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
        label: ""
    }),
    "progress tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egeJ8))), {
        label: ""
    }),
    "project management": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fqjcR))), {
        label: ""
    }),
    "reporting": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d1xAD))), {
        label: ""
    }),
    "requirements": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lhvME))), {
        label: ""
    }),
    "resource": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bKqge))), {
        label: ""
    }),
    "retrospective": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kGv70))), {
        label: ""
    }),
    "risk assessment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
        label: ""
    }),
    "roadmaps": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOabo))), {
        label: ""
    }),
    "stakeholder alignment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($itghZ))), {
        label: ""
    }),
    "task planning": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNevM))), {
        label: ""
    }),
    "task tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HBdl))), {
        label: ""
    }),
    "team alignment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHnIP))), {
        label: ""
    }),
    "team collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHnIP))), {
        label: ""
    }),
    "workflows": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($haaTf))), {
        label: ""
    })
};
const $d661b68c903e32f4$export$16b26cd5e98d9100 = (feature)=>{
    var _featureIconMap_feature_toLowerCase;
    return (_featureIconMap_feature_toLowerCase = $d661b68c903e32f4$var$featureIconMap[feature.toLowerCase()]) !== null && _featureIconMap_feature_toLowerCase !== void 0 ? _featureIconMap_feature_toLowerCase : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHyWi))), {
        label: ""
    });
};

});
parcelRegister("kkNq7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecdc02c1caa631e5$var$_react = $ecdc02c1caa631e5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $ecdc02c1caa631e5$var$_backlog = $ecdc02c1caa631e5$var$_interopRequireDefault((parcelRequire("7fq8b")));
function $ecdc02c1caa631e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ecdc02c1caa631e5$var$BacklogIcon = (props)=>/*#__PURE__*/ $ecdc02c1caa631e5$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $ecdc02c1caa631e5$var$_backlog.default
    }));
$ecdc02c1caa631e5$var$BacklogIcon.displayName = "BacklogIcon";
var $ecdc02c1caa631e5$var$_default = module.exports.default = $ecdc02c1caa631e5$var$BacklogIcon;

});

parcelRegister("2eqAL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a01842f93cc26da$var$_react = $1a01842f93cc26da$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $1a01842f93cc26da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a01842f93cc26da$var$BillingIcon = (props)=>/*#__PURE__*/ $1a01842f93cc26da$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$1a01842f93cc26da$var$BillingIcon.displayName = "BillingIcon";
var $1a01842f93cc26da$var$_default = module.exports.default = $1a01842f93cc26da$var$BillingIcon;

});

parcelRegister("kGv70", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0efdd17975cfad6$var$_react = $f0efdd17975cfad6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f0efdd17975cfad6$var$_board = $f0efdd17975cfad6$var$_interopRequireDefault((parcelRequire("lPup9")));
function $f0efdd17975cfad6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0efdd17975cfad6$var$BoardIcon = (props)=>/*#__PURE__*/ $f0efdd17975cfad6$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $f0efdd17975cfad6$var$_board.default
    }));
$f0efdd17975cfad6$var$BoardIcon.displayName = "BoardIcon";
var $f0efdd17975cfad6$var$_default = module.exports.default = $f0efdd17975cfad6$var$BoardIcon;

});

parcelRegister("bKqge", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88d85c6fd5282691$var$_react = $88d85c6fd5282691$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $88d85c6fd5282691$var$_bookWithBookmark = $88d85c6fd5282691$var$_interopRequireDefault((parcelRequire("kqqsh")));
function $88d85c6fd5282691$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88d85c6fd5282691$var$BookIcon = (props)=>/*#__PURE__*/ $88d85c6fd5282691$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 6.002v9.996c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.449.995-1.002V6.002C17 5.456 16.554 5 16.005 5h-8.01C7.455 5 7 5.449 7 6.002m-2 0A3.005 3.005 0 0 1 7.995 3h8.01A3.003 3.003 0 0 1 19 6.002v9.996A3.005 3.005 0 0 1 16.005 19h-8.01A3.003 3.003 0 0 1 5 15.998z"/><path d="M9 7h6v4H9zm0 6h6v2H9zm1 7.86V20H7v.86L8.5 20zM7 18h3v2H7z"/></g></svg>`
    }, props, {
        newIcon: $88d85c6fd5282691$var$_bookWithBookmark.default
    }));
$88d85c6fd5282691$var$BookIcon.displayName = "BookIcon";
var $88d85c6fd5282691$var$_default = module.exports.default = $88d85c6fd5282691$var$BookIcon;

});

parcelRegister("judwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2fb4f7342147a3d$var$_react = $e2fb4f7342147a3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $e2fb4f7342147a3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e2fb4f7342147a3d$var$CameraTakePictureIcon = (props)=>/*#__PURE__*/ $e2fb4f7342147a3d$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="12" r="5"/><path fill-rule="nonzero" d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"/></g></svg>`
    }, props));
$e2fb4f7342147a3d$var$CameraTakePictureIcon.displayName = "CameraTakePictureIcon";
var $e2fb4f7342147a3d$var$_default = module.exports.default = $e2fb4f7342147a3d$var$CameraTakePictureIcon;

});

parcelRegister("j6Mjf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de940d15d276efdb$var$_react = $de940d15d276efdb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $de940d15d276efdb$var$_comment = $de940d15d276efdb$var$_interopRequireDefault((parcelRequire("ctYD4")));
function $de940d15d276efdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de940d15d276efdb$var$CommentIcon = (props)=>/*#__PURE__*/ $de940d15d276efdb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $de940d15d276efdb$var$_comment.default
    }));
$de940d15d276efdb$var$CommentIcon.displayName = "CommentIcon";
var $de940d15d276efdb$var$_default = module.exports.default = $de940d15d276efdb$var$CommentIcon;

});

parcelRegister("54Z58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b2cb50a58f9d7c1$var$_react = $3b2cb50a58f9d7c1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3b2cb50a58f9d7c1$var$_decision = $3b2cb50a58f9d7c1$var$_interopRequireDefault((parcelRequire("jcATf")));
function $3b2cb50a58f9d7c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b2cb50a58f9d7c1$var$DecisionIcon = (props)=>/*#__PURE__*/ $3b2cb50a58f9d7c1$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="m19.29 3.29-5 5A1 1 0 1 0 15.7 9.7l5-5a1 1 0 1 0-1.41-1.41M8.04 4.93a.96.96 0 1 0 .01-1.91L4.06 3A1.05 1.05 0 0 0 3 4.04l.02 4a.96.96 0 0 0 1.92-.01l-.02-3.11z"/><path d="M11 19.998A1 1 0 0 0 12 21c.552 0 1-.454 1-1.007v-7.4c0-.556-.315-1.322-.705-1.713L5.207 3.793 3.793 5.207 11 12.414z"/></g></svg>`
    }, props, {
        newIcon: $3b2cb50a58f9d7c1$var$_decision.default
    }));
$3b2cb50a58f9d7c1$var$DecisionIcon.displayName = "DecisionIcon";
var $3b2cb50a58f9d7c1$var$_default = module.exports.default = $3b2cb50a58f9d7c1$var$DecisionIcon;

});

parcelRegister("9TuM8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73411f76379301d6$var$_react = $73411f76379301d6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $73411f76379301d6$var$_department = $73411f76379301d6$var$_interopRequireDefault((parcelRequire("20L2t")));
function $73411f76379301d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73411f76379301d6$var$DepartmentIcon = (props)=>/*#__PURE__*/ $73411f76379301d6$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M11 5v2h2V5zm0 6V9h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v2h5a1 1 0 0 1 1 1v3h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-2H7v2h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-3a1 1 0 0 1 1-1zm-6 6v2h2v-2zm12 0v2h2v-2z"/></svg>`
    }, props, {
        newIcon: $73411f76379301d6$var$_department.default
    }));
$73411f76379301d6$var$DepartmentIcon.displayName = "DepartmentIcon";
var $73411f76379301d6$var$_default = module.exports.default = $73411f76379301d6$var$DepartmentIcon;

});

parcelRegister("8nSEF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61aade0ef464e452$var$_react = $61aade0ef464e452$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $61aade0ef464e452$var$_file = $61aade0ef464e452$var$_interopRequireDefault((parcelRequire("jwsof")));
function $61aade0ef464e452$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61aade0ef464e452$var$DocumentIcon = (props)=>/*#__PURE__*/ $61aade0ef464e452$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/></svg>`
    }, props, {
        newIcon: $61aade0ef464e452$var$_file.default
    }));
$61aade0ef464e452$var$DocumentIcon.displayName = "DocumentIcon";
var $61aade0ef464e452$var$_default = module.exports.default = $61aade0ef464e452$var$DocumentIcon;

});

parcelRegister("kPkjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f298551cfda52fdb$var$_react = $f298551cfda52fdb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f298551cfda52fdb$var$_file = $f298551cfda52fdb$var$_interopRequireDefault((parcelRequire("jwsof")));
function $f298551cfda52fdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f298551cfda52fdb$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $f298551cfda52fdb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $f298551cfda52fdb$var$_file.default
    }));
$f298551cfda52fdb$var$DocumentFilledIcon.displayName = "DocumentFilledIcon";
var $f298551cfda52fdb$var$_default = module.exports.default = $f298551cfda52fdb$var$DocumentFilledIcon;

});

parcelRegister("dtz0w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf9238aeadd75b4$var$_react = $9cf9238aeadd75b4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $9cf9238aeadd75b4$var$_files = $9cf9238aeadd75b4$var$_interopRequireDefault((parcelRequire("wQpQg")));
function $9cf9238aeadd75b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cf9238aeadd75b4$var$DocumentsIcon = (props)=>/*#__PURE__*/ $9cf9238aeadd75b4$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1zm13-6.99V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.52c0-.3-.13-.58-.36-.77l-5.07-4.24c-.36-.3-.81-.46-1.28-.46H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.99z"/></svg>`
    }, props, {
        newIcon: $9cf9238aeadd75b4$var$_files.default
    }));
$9cf9238aeadd75b4$var$DocumentsIcon.displayName = "DocumentsIcon";
var $9cf9238aeadd75b4$var$_default = module.exports.default = $9cf9238aeadd75b4$var$DocumentsIcon;

});

parcelRegister("imXhV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5f8457061b67753$var$_react = $d5f8457061b67753$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d5f8457061b67753$var$_edit = $d5f8457061b67753$var$_interopRequireDefault((parcelRequire("aRydc")));
function $d5f8457061b67753$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5f8457061b67753$var$EditIcon = (props)=>/*#__PURE__*/ $d5f8457061b67753$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $d5f8457061b67753$var$_edit.default
    }));
$d5f8457061b67753$var$EditIcon.displayName = "EditIcon";
var $d5f8457061b67753$var$_default = module.exports.default = $d5f8457061b67753$var$EditIcon;

});

parcelRegister("bJ0Y9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8894a626592c4b72$var$_react = $8894a626592c4b72$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $8894a626592c4b72$var$_emoji = $8894a626592c4b72$var$_interopRequireDefault((parcelRequire("j25Ho")));
function $8894a626592c4b72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8894a626592c4b72$var$EmojiIcon = (props)=>/*#__PURE__*/ $8894a626592c4b72$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 16.071c3.9 0 7.071-3.171 7.071-7.071S15.9 4.929 12 4.929A7.08 7.08 0 0 0 4.929 12c0 3.9 3.171 7.071 7.071 7.071m-1.929-7.714a1.286 1.286 0 1 1 .001-2.572 1.286 1.286 0 0 1 0 2.572m3.858 0a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572m.347 2.035a.805.805 0 0 1 1.198 1.073A4.67 4.67 0 0 1 12 16.018a4.67 4.67 0 0 1-3.469-1.548.804.804 0 0 1 1.196-1.074c1.158 1.29 3.393 1.29 4.549-.004"/></svg>`
    }, props, {
        newIcon: $8894a626592c4b72$var$_emoji.default
    }));
$8894a626592c4b72$var$EmojiIcon.displayName = "EmojiIcon";
var $8894a626592c4b72$var$_default = module.exports.default = $8894a626592c4b72$var$EmojiIcon;

});

parcelRegister("d1xAD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97b56c9b9eb8a32b$var$_react = $97b56c9b9eb8a32b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $97b56c9b9eb8a32b$var$_folderClosed = $97b56c9b9eb8a32b$var$_interopRequireDefault((parcelRequire("ehFjV")));
function $97b56c9b9eb8a32b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $97b56c9b9eb8a32b$var$FolderIcon = (props)=>/*#__PURE__*/ $97b56c9b9eb8a32b$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $97b56c9b9eb8a32b$var$_folderClosed.default
    }));
$97b56c9b9eb8a32b$var$FolderIcon.displayName = "FolderIcon";
var $97b56c9b9eb8a32b$var$_default = module.exports.default = $97b56c9b9eb8a32b$var$FolderIcon;

});
parcelRegister("ehFjV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0bcbb1797ade28bc1c80b60f118d24e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a662b49752416b07$var$_react = $a662b49752416b07$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a662b49752416b07$var$_baseNew = $a662b49752416b07$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $a662b49752416b07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a662b49752416b07$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $a662b49752416b07$var$_react.default.createElement($a662b49752416b07$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$a662b49752416b07$var$FolderClosedIcon.displayName = "FolderClosedIcon";
var $a662b49752416b07$var$_default = module.exports.default = $a662b49752416b07$var$FolderClosedIcon;

});


parcelRegister("DynGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076e5001bf288d85$var$_react = $076e5001bf288d85$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $076e5001bf288d85$var$_personAdd = $076e5001bf288d85$var$_interopRequireDefault((parcelRequire("g0xEi")));
function $076e5001bf288d85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $076e5001bf288d85$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $076e5001bf288d85$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $076e5001bf288d85$var$_personAdd.default
    }));
$076e5001bf288d85$var$InviteTeamIcon.displayName = "InviteTeamIcon";
var $076e5001bf288d85$var$_default = module.exports.default = $076e5001bf288d85$var$InviteTeamIcon;

});

parcelRegister("cNevM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95055157ec33958b$var$_react = $95055157ec33958b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $95055157ec33958b$var$_workItem = $95055157ec33958b$var$_interopRequireDefault((parcelRequire("5DJNp")));
function $95055157ec33958b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95055157ec33958b$var$IssueIcon = (props)=>/*#__PURE__*/ $95055157ec33958b$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $95055157ec33958b$var$_workItem.default
    }));
$95055157ec33958b$var$IssueIcon.displayName = "IssueIcon";
var $95055157ec33958b$var$_default = module.exports.default = $95055157ec33958b$var$IssueIcon;

});
parcelRegister("5DJNp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41b41e64872b655c$var$_react = $41b41e64872b655c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $41b41e64872b655c$var$_baseNew = $41b41e64872b655c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $41b41e64872b655c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41b41e64872b655c$var$WorkItemIcon = (props)=>/*#__PURE__*/ $41b41e64872b655c$var$_react.default.createElement($41b41e64872b655c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$41b41e64872b655c$var$WorkItemIcon.displayName = "WorkItemIcon";
var $41b41e64872b655c$var$_default = module.exports.default = $41b41e64872b655c$var$WorkItemIcon;

});


parcelRegister("e9JPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4e573be262049b5$var$_react = $a4e573be262049b5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $a4e573be262049b5$var$_lightbulb = $a4e573be262049b5$var$_interopRequireDefault((parcelRequire("foKoE")));
function $a4e573be262049b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4e573be262049b5$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $a4e573be262049b5$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $a4e573be262049b5$var$_lightbulb.default
    }));
$a4e573be262049b5$var$LightbulbFilledIcon.displayName = "LightbulbFilledIcon";
var $a4e573be262049b5$var$_default = module.exports.default = $a4e573be262049b5$var$LightbulbFilledIcon;

});

parcelRegister("lhvME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7e3d70f77f45299$var$_react = $f7e3d70f77f45299$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $f7e3d70f77f45299$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7e3d70f77f45299$var$ListIcon = (props)=>/*#__PURE__*/ $f7e3d70f77f45299$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M3 18a1 1 0 0 0 .99 1H20a.99.99 0 0 0 1-1v-1H3zm0-7h18V9H3zm0-4h18V6c0-.55-.44-1-.99-1H3.99A.99.99 0 0 0 3 6zm0 8h18v-2H3z"/></svg>`
    }, props));
$f7e3d70f77f45299$var$ListIcon.displayName = "ListIcon";
var $f7e3d70f77f45299$var$_default = module.exports.default = $f7e3d70f77f45299$var$ListIcon;

});

parcelRegister("fqjcR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3a82eb5ce64069c$var$_react = $b3a82eb5ce64069c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $b3a82eb5ce64069c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3a82eb5ce64069c$var$PortfolioIcon = (props)=>/*#__PURE__*/ $b3a82eb5ce64069c$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.83 17h6.34a3.001 3.001 0 1 1 0 2H8.83a3.001 3.001 0 1 1 0-2M3 5c0-1.105.895-2 1.994-2h12.012C18.107 3 19 3.888 19 5c0 1.105-.895 2-1.994 2H4.994A1.99 1.99 0 0 1 3 5m5 6a2 2 0 0 1 2.003-2h8.994a2 2 0 1 1 0 4h-8.994A1.996 1.996 0 0 1 8 11"/></svg>`
    }, props));
$b3a82eb5ce64069c$var$PortfolioIcon.displayName = "PortfolioIcon";
var $b3a82eb5ce64069c$var$_default = module.exports.default = $b3a82eb5ce64069c$var$PortfolioIcon;

});

parcelRegister("haaTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7ebd15dd5a3a3bb$var$_react = $c7ebd15dd5a3a3bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c7ebd15dd5a3a3bb$var$_sprint = $c7ebd15dd5a3a3bb$var$_interopRequireDefault((parcelRequire("cv7vZ")));
function $c7ebd15dd5a3a3bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7ebd15dd5a3a3bb$var$SprintIcon = (props)=>/*#__PURE__*/ $c7ebd15dd5a3a3bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $c7ebd15dd5a3a3bb$var$_sprint.default
    }));
$c7ebd15dd5a3a3bb$var$SprintIcon.displayName = "SprintIcon";
var $c7ebd15dd5a3a3bb$var$_default = module.exports.default = $c7ebd15dd5a3a3bb$var$SprintIcon;

});
parcelRegister("cv7vZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $919e359f42e14ab3$var$_react = $919e359f42e14ab3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $919e359f42e14ab3$var$_baseNew = $919e359f42e14ab3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $919e359f42e14ab3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $919e359f42e14ab3$var$SprintIcon = (props)=>/*#__PURE__*/ $919e359f42e14ab3$var$_react.default.createElement($919e359f42e14ab3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$919e359f42e14ab3$var$SprintIcon.displayName = "SprintIcon";
var $919e359f42e14ab3$var$_default = module.exports.default = $919e359f42e14ab3$var$SprintIcon;

});


parcelRegister("egeJ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a61dfbc9e4aeb074$var$_react = $a61dfbc9e4aeb074$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $a61dfbc9e4aeb074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a61dfbc9e4aeb074$var$StatusIcon = (props)=>/*#__PURE__*/ $a61dfbc9e4aeb074$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$a61dfbc9e4aeb074$var$StatusIcon.displayName = "StatusIcon";
var $a61dfbc9e4aeb074$var$_default = module.exports.default = $a61dfbc9e4aeb074$var$StatusIcon;

});

parcelRegister("2HBdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f7c76e463f4d85f$var$_react = $1f7c76e463f4d85f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $1f7c76e463f4d85f$var$_subtasks = $1f7c76e463f4d85f$var$_interopRequireDefault((parcelRequire("1i7Rp")));
function $1f7c76e463f4d85f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f7c76e463f4d85f$var$SubtaskIcon = (props)=>/*#__PURE__*/ $1f7c76e463f4d85f$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $1f7c76e463f4d85f$var$_subtasks.default
    }));
$1f7c76e463f4d85f$var$SubtaskIcon.displayName = "SubtaskIcon";
var $1f7c76e463f4d85f$var$_default = module.exports.default = $1f7c76e463f4d85f$var$SubtaskIcon;

});
parcelRegister("1i7Rp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f0d91d0e8faa7c8$var$_react = $0f0d91d0e8faa7c8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0f0d91d0e8faa7c8$var$_baseNew = $0f0d91d0e8faa7c8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0f0d91d0e8faa7c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f0d91d0e8faa7c8$var$SubtasksIcon = (props)=>/*#__PURE__*/ $0f0d91d0e8faa7c8$var$_react.default.createElement($0f0d91d0e8faa7c8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$0f0d91d0e8faa7c8$var$SubtasksIcon.displayName = "SubtasksIcon";
var $0f0d91d0e8faa7c8$var$_default = module.exports.default = $0f0d91d0e8faa7c8$var$SubtasksIcon;

});


parcelRegister("iHnIP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9cea4d76be7ef3d$var$_react = $d9cea4d76be7ef3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d9cea4d76be7ef3d$var$_teams = $d9cea4d76be7ef3d$var$_interopRequireDefault((parcelRequire("eH5ui")));
function $d9cea4d76be7ef3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9cea4d76be7ef3d$var$TeamsIcon = (props)=>/*#__PURE__*/ $d9cea4d76be7ef3d$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $d9cea4d76be7ef3d$var$_teams.default
    }));
$d9cea4d76be7ef3d$var$TeamsIcon.displayName = "TeamsIcon";
var $d9cea4d76be7ef3d$var$_default = module.exports.default = $d9cea4d76be7ef3d$var$TeamsIcon;

});

parcelRegister("lnsmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f901beaf7c898181$var$_react = $f901beaf7c898181$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f901beaf7c898181$var$_eyeOpen = $f901beaf7c898181$var$_interopRequireDefault((parcelRequire("cm6I6")));
function $f901beaf7c898181$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f901beaf7c898181$var$WatchIcon = (props)=>/*#__PURE__*/ $f901beaf7c898181$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $f901beaf7c898181$var$_eyeOpen.default
    }));
$f901beaf7c898181$var$WatchIcon.displayName = "WatchIcon";
var $f901beaf7c898181$var$_default = module.exports.default = $f901beaf7c898181$var$WatchIcon;

});

parcelRegister("6akvZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47d3971a68f6de4a$var$_react = $47d3971a68f6de4a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $47d3971a68f6de4a$var$_globe = $47d3971a68f6de4a$var$_interopRequireDefault((parcelRequire("5XRUs")));
function $47d3971a68f6de4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47d3971a68f6de4a$var$WorldIcon = (props)=>/*#__PURE__*/ $47d3971a68f6de4a$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $47d3971a68f6de4a$var$_globe.default
    }));
$47d3971a68f6de4a$var$WorldIcon.displayName = "WorldIcon";
var $47d3971a68f6de4a$var$_default = module.exports.default = $47d3971a68f6de4a$var$WorldIcon;

});



//# sourceMappingURL=confluence-template-category-page.bdca01fd.js.map
